import { formatCurrency } from 'common/FormatUtilities';
import { Tooltip } from 'src/shared/design-system/Tooltip';
import { Line, Text, TextContainer } from './styles';

export const SmallOrderFeeLine = ({
  smallOrderFee,
  remainingToRemoveFee,
}: {
  smallOrderFee: number;
  remainingToRemoveFee: number;
}) => (
  <Line>
    <TextContainer>
      <Text>Small Order Fee</Text>
      <Tooltip
        content={`Save ${formatCurrency(smallOrderFee)} when you add ${formatCurrency(
          remainingToRemoveFee
        )} to your order.`}
        showInfoCircle
        positions={['right', 'top', 'bottom', 'left']}
      />
    </TextContainer>
    <Text>{formatCurrency(smallOrderFee)}</Text>
  </Line>
);
